<template>
  <page>
    <module :title="isNotice ? '最新公告' : '新手入门'">
      <div class="article-list-layout">
        <c-table ref="list" height="grow" :paging="true">
          <c-table-column :label="isNotice ? '公告标题' : '教程标题'" name="title">
            <template #default="{ data }">
              <a :class="{'article-read': Number(data.is_read) === 1}" @click="navigateTo('/article/' + article_type + '/detail/' + data.id)">{{ data.title }}</a>
              <span v-if="isNotice && Number(data.is_new) === 1" class="article-new">NEW</span>
            </template>
          </c-table-column>
          <c-table-column v-if="isNotice" label="分类" name="consultation_name" width="120" />
          <c-table-column :label="isNotice ? '发布时间' : '更新时间'" :name="isNotice ? 'create_date' : 'update_date'" width="180" />
        </c-table>
      </div>
    </module>
  </page>
</template>

<script>
export default {
  props: {
    article_type: {
      type: String,
      required: true
    }
  },
  computed: {
    isNotice() {
      return this.article_type === '1';
    }
  },
  mounted() {
    this.loadArticles();
  },
  watch: {
    article_type() {
      this.loadArticles();
    }
  },
  methods: {
    loadArticles() {
      this.$refs.list.load({
        url: "/article/published/list",
        data: { article_type: this.article_type }
      });
    }
  }
};
</script>

<style scoped>
a.article-read { color: #aaa; }
.article-new { margin-left: 8px; padding: 1px 4px; color: #fff; background: #ff4d4f; border-radius: 2px; font-size: 10px; font-weight: bold; }
.c-page {
  height: 100%;
}
.c-module {
  height: 100%;
}
.article-list-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
